import { NgxLoggerLevel } from 'ngx-logger';

export const ENV = {
    DATA_GATEWAY_URL: 'https://fr-ist-vedif-jimi-prd.appspot.com/_ah/api/jimi/v1/',
    INO_CLIENT_ID: '218518105267-dgt99uqrdmusikph2c545kivg8q2acup.apps.googleusercontent.com',
    IOS_LOGIN_CLIENT_ID: '',
    MAPS_API_KEY:  'AIzaSyCsXqc5zxOgcXsRABCRHKKY1c5vl6edqtU',
    FIREBASE_CONFIG: {
        apiKey: 'AIzaSyC4Pdf_iKrsYUXxVg4xPFOMrr3_4k9tKtQ',
        authDomain: 'fr-ist-vedif-jimi-prd.firebaseapp.com',
        databaseURL: 'https://fr-ist-vedif-jimi-prd.firebaseio.com',
        projectId: 'fr-ist-vedif-jimi-prd',
        storageBucket: 'fr-ist-vedif-jimi-prd.appspot.com',
        messagingSenderId: '218518105267',
    },
    SIGMA_URL: 'https://sigmav2.app.vedif.net/maximo/ui/?skin=tablette&event=loadapp&value=ved_pwo&additionalevent=useqbe&additionaleventvalue=SITEID=VEDIF1%7CWONUM={0}&forcereload=true',
    SIGMA_URL_CANA: 'https://sigmav2.app.vedif.net/maximo/ui/?skin=tablette&event=loadapp&value=VED_PWOCAN&additionalevent=useqbe&additionaleventvalue=SITEID=VEDIF1%7CWONUM={0}&forcereload=true',
    ATLAS_URL: 'https://atlasweb.app.vedif.net/VedifAtlasSecurity/sig/Index.aspx?ServiceName=CouchesApplicatives&ServiceLayer=14&FieldName=NUM_CHANTIER&FieldValue={0}',
    URGENCE_FUITE_PHONE: '',
    LOG_LEVEL: NgxLoggerLevel.OFF,
    HUB_API_URL: 'https://api.veolia.com',
    HUB_API_EP: '/hub-api/v1',
    EMAIL_SUPPORT: 'fr.water.franciliane.jimi-support.all.groups@veolia.com',
    ESB_GATEWAY_URL: 'https://esb-client-dot-fr-ist-vedif-jimi-prd.appspot.com/api/',
    ROCK_URL: 'https://rock-vedif.lightning.force.com/lightning/r/Case/',
    VISIBLE_CAPTCHA_URL: '6LexJrkUAAAAAPTkqLZIQI858RAUyu3ds04qUcJ5',
    INVISIBLE_CAPTCHA_URL: '6Le8JrkUAAAAADaufLhSqxpaMh3RJQZB7OR-VuBj',
    APIGEE_KEY: '5qplHGBlWeFUSVXBT1jA3D3q09RZspW5uBfYA0YS1u5vUf1Z',
    APIGEE_SECRET: 'PY0Uy4mXVMKTFh5NitIpK2GMQFfrBY1xzIe7LbvGV386qYC7pDYMqE3GtdO3IMui',
};
